import React from 'react'
import "./Schw.css"
import SchwHead from './SchwHead'
import SchwCardContain from './SchwCardContain'
const Schw = () => {
  return (
    <div className='schwContainer'>
      <SchwHead/>
      <SchwCardContain/>
    </div>
  )
}

export default Schw
